export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_EMPRESA = 'empresa';
export const SET_CENTRO_CUSTO = 'centroCusto';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_RESPONSAVEL = 'responsavel';
export const SET_DATA_FINAL = 'dataFinal';
export const SET_DATA_INICIAL = 'dataInicial';
export const SET_URGENCIA = 'urgencia';
export const SET_COMPRADOR_RESPONSAVEL = 'compradorResponsavel';
export const SET_GRUPO = 'grupo';
export const SET_SITUACAO = 'situacao';
